/**
 * Created by USER on 18/6/12.
 */
export const GET_BLOG = 'GET_BLOG';
export const GET_SINGLE_BLOG = 'GET_SINGLE_BLOG';

export function getBlog(data) {
  return {
    type: GET_BLOG,
    data
  };
}

export function getSingleBlog(data) {
  return {
    type: GET_SINGLE_BLOG,
    data
  };
}